import { Box, Text, Flex } from "@chakra-ui/react";
import { NewOrderForm, useNewOrderStore } from "../stores/order.store";
import { VariantOption } from "../types/earmold.types";
import { useEarmoldVariants } from "../hooks/earmolds.hooks";
import { useMemo } from "react";
import FileIconPng from "./icons/files/FileIconPng";
import { DownloadIcon } from "@chakra-ui/icons";
import { useMutation } from "react-query";
import { fetchFileContent } from "../mutations/file.mutations";
import EarmoldTitle from "./EarmoldTitle";

const KeyValue = ({
  earmold,
  id,
  option,
}: {
  earmold?: number | string;
  id: string;
  option?: VariantOption | null;
}) => {
  const { data: variants } = useEarmoldVariants(earmold);

  const label = useMemo(() => {
    const variantFound = variants?.find(
      (variant) => variant.id.toString() === id.toString()
    );
    if (variantFound) {
      return variantFound.label;
    }
    return "--";
  }, [variants, id]);
  return (
    <Flex
      justifyContent="space-between"
      borderBottom="solid 1px"
      borderColor="gray.200"
      mx={2}
      px={2}
      py={2}
      alignItems={"center"}
    >
      <Text
        lineHeight="18px"
        fontSize="12px"
        fontWeight="400"
        color="gray.500"
        w="100%"
      >
        {label}
      </Text>
      <Text
        lineHeight="21px"
        fontSize="14px"
        fontWeight="400"
        textAlign="left"
        w="100%"
      >
        {option?.label}
      </Text>
    </Flex>
  );
};

const RightEarCard = ({
  earmold,
  form,
}: {
  earmold?: number | string;
  form?: NewOrderForm;
}) => {
  const { rightFile, hasRightEar } = useNewOrderStore();
  const { mutate: downloadFileContent } = useMutation(fetchFileContent, {
    onSuccess: (content: string) => {
      const blob = new Blob([content]);
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = rightFile ? rightFile.fileName : "file";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  });

  if (!hasRightEar) {
    return <Box></Box>;
  }
  return (
    <Box w="100%" border="solid 1px" borderColor="gray.200" borderRadius="xl">
      <Flex
        bgColor="#FEF2F2"
        borderTopRadius="xl"
        justifyContent="center"
        py={2}
        borderBottom="solid 1px"
        borderColor="gray.200"
        direction="column"
        alignItems="center"
      >
        <Text lineHeight="21px" fontSize="16px" fontWeight="600">
          Détails de l'oreille droite
        </Text>
        {earmold && <EarmoldTitle earmold={earmold} />}
        {rightFile && (
          <>
            <Flex
              justify="center"
              justifyContent="center"
              alignItems="center"
              gap={4}
              my={3}
              onClick={() => {
                if (rightFile) {
                  downloadFileContent(rightFile.id);
                }
              }}
            >
              <Flex gap={4}>
                <FileIconPng color="brand.700" w="24px" h="24px" />
                <Text>{rightFile.fileName}</Text>
              </Flex>
              <DownloadIcon />
            </Flex>
          </>
        )}
      </Flex>
      <Flex direction="column">
        {form &&
          Object.entries(form).map(([label, value]) => (
            <KeyValue earmold={earmold} id={label} option={value} />
          ))}
      </Flex>
    </Box>
  );
};

export default RightEarCard;
